import React, {useMemo, useRef, useState} from 'react';
import {useAPI} from "../../../config/API";
import Form, {FormInputComponent} from "../../../components/form/Form";
import {Modal, Select} from "antd";

const CoverLetterTemplateModal = ({onSubmit, isDisabled, onFetch,requestParams = {},  ...props}) => {

    const [selectedCoverLetter, setSelectedCoverLetter] = useState(null);
    const [isCoverLetterModalOpen, setIsCoverLetterModalOpen] = useState(false);

    const coverletterBtnRef = useRef(null);
    const {
        data: coverLetters,
        isLoading,
        error,
        refetch,
        ...result
    } = useAPI(['fetchCoverLettersForTalent', requestParams], {
        onSuccess: (response) => {
            console.log('onSuccess', response);
            onFetch(response)
        }
    });

    const coverLetterOptions = useMemo(() => {
        if (isLoading || !coverLetters?.length) {
            return []
        }
        return TB.map(coverLetters, letter => {
            return {
                ...letter,
                label: (
                    <div className="my-2.5">
                        <p className="inline whitespace-normal">
                            <span className="font-medium">
                                {TB.moment(letter.created_at).format('l')}
                                &nbsp;
                                <span className="text-info font-medium">
                                {letter.position?.title}</span>
                                &nbsp;-&nbsp;
                            </span>
                            <span>
                                {TB.truncate(TB.stripHtml(letter.cover_letter), {length: 150})}
                            </span>
                        </p>
                    </div>
                ),
                value: letter.job_candidate_id
            }
        })
    }, [isLoading, coverLetters]);

    const onClose = async () => {
        await setSelectedCoverLetter(null)
        return setIsCoverLetterModalOpen(false)
    }

    if (!coverLetterOptions?.length) {
        return null;
    }
    return (
        <React.Fragment>
            <button
                ref={coverletterBtnRef}
                disabled={isDisabled}
                type="button"
                onClick={() => setIsCoverLetterModalOpen(true)}
                className={"toolbar-item spaced"}
                aria-label="Template"
            >
                <p className="text-xxs">My Cover Letters</p>
            </button>
            <Modal
                onCancel={onClose}
                closable={true}
                footer={false}
                destroyOnClose={true}
                width={600}
                title={false}
                open={isCoverLetterModalOpen}
                zIndex={101}
                getContainer={coverletterBtnRef ? () => coverletterBtnRef?.current : undefined}
            >
                <div className="min-h-[300px] flex flex-col items-stretch justify-between">


                    {selectedCoverLetter ? (
                        <div>
                            <p className="mb-4 text-base font-semibold">
                                Would you like to use this cover letter as a template?
                            </p>
                            <div className="flex flex-col gap-3 items-start">
                                <p className="text-xs">
                                    <span className="font-medium">Role: </span>
                                    <span>{selectedCoverLetter.position?.title}</span>
                                </p>
                                <p className="text-xs">
                                    <span className="font-medium">Date Submitted: </span>
                                    <span>{TB.moment(selectedCoverLetter.created_at).format('l')}</span>
                                </p>
                                <div className="relative w-full text-left">
                                    <p className="text-xs mb-1.5">
                                        <span className="font-medium">Content: </span>
                                    </p>
                                    <div className="rich-text-display">
                                        <span dangerouslySetInnerHTML={{__html: selectedCoverLetter.cover_letter}}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <Form
                            background={"transparent"}
                            onSubmit={null}
                            minimal
                            submitButton={false}
                            isDisabled={isDisabled}
                            model={{selected_cover_letter: selectedCoverLetter}}
                            fields={[]}
                            onChange={async (model) => {
                                let letter = TB.find(coverLetterOptions, ['job_candidate_id', parseInt(model.selected_cover_letter)])
                                return setSelectedCoverLetter(letter)
                            }}>

                            <p className="text-base font-semibold mb-2">
                                Use a Cover Letter Template
                            </p>
                            <p className="mb-8 text-sm">
                                Want to save time and use a previously submitted cover letter?
                                Use the dropdown below to see your past cover letters for other roles.
                                Select one to use as a template for this role.
                            </p>
                            {coverLetterOptions && (
                                <FormInputComponent
                                    type="antd-input"
                                    value={selectedCoverLetter}
                                    className="mb-3"
                                    fieldName="selected_cover_letter"
                                    label={false}
                                    placeholder="Select an option..."
                                    required={false}>

                                    <Select popupClassName="cover-letter-options" options={coverLetterOptions}/>

                                </FormInputComponent>
                            )}

                        </Form>
                    )}
                    <div className="mt-8 flex flex-row justify-end">

                        {selectedCoverLetter ? (
                            <React.Fragment>
                                <button onClick={() => setSelectedCoverLetter(null)}
                                        className="btn btn-primary text-xs">
                                    Choose another template
                                </button>
                                <button type="button" onClick={async () => {

                                    await onSubmit({
                                        cover_letter: selectedCoverLetter.cover_letter,
                                        selected_cover_letter: selectedCoverLetter.job_candidate_id || TB.uuid()
                                    })
                                    return onClose();
                                }} className="btn btn-dark ml-3 text-xs"
                                        disabled={isDisabled || !selectedCoverLetter}>
                                    Yes, Continue
                                </button>
                            </React.Fragment>

                        ) : (
                            <button className="btn btn-outline-dark text-xs"
                                    type="button" onClick={onClose}
                                    disabled={isDisabled}>
                                Cancel
                            </button>
                        )}


                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
};

export default CoverLetterTemplateModal;